/* eslint-disable babel/camelcase */
import React from "react";
import ReactDOM from "react-dom";
import ErrorPage from "venuescanner-js/react/components/ErrorPage";
import { popup } from "venuescanner-js/vanilla/components/popup";
import { reportError } from "venuescanner-js/react/services/errorService";
import Details from "./Details";
class ErrorBoundary extends React.Component {
  state = {
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    reportError("SignIn Details", error, errorInfo);
  }

  render() {
    const { state, props } = this;
    if (state.error) {
      return <ErrorPage />;
    }
    return <Details {...props} />;
  }
}

export default ({ onSaved, user }) => {
  const div = document.createElement("div");
  popup.show(div, { fullscreen: true, closable: false, overIntercom: true });
  ReactDOM.render(
    <ErrorBoundary
      user={user}
      saved={(data) => {
        if (onSaved) onSaved(data);
        popup.close();
      }}
    />,
    div
  );
};
